import ueditor from './ueditor';
import newTag from './newTag';
import qeditor from './qeditor';
export default {
  install(Vue) {
    Vue.component('ueditor', ueditor);
    Vue.component('newTag', newTag);
    Vue.component('qeditor', qeditor);
  }
}



// WEBPACK FOOTER //
// ./src/common/component/index.js